// authActions.js
export const loadUserFromLocalStorage = () => (dispatch) => {
  const token = localStorage.getItem('authToken');
  const expiration = localStorage.getItem('authExpiration');
  
  if (token && expiration && Date.now() < expiration) {
    const user = JSON.parse(localStorage.getItem('authUser')); // Assuming user is stored in localStorage
    dispatch({
      type: 'LOAD_USER_FROM_LOCAL_STORAGE',
      payload: user,
    });
  }
};
